<template>
  <a 
    @mouseenter="isHover=true" 
    @mouseleave="isHover=false" 
    :class="isHover ? 'hover-effect' : ''"
    class="min-h-96-5 lg:min-h-150 w-72 lg:w-72 card-width lg2:w-76 lg3:w-82 bg-white rounded-md card-shadow flex flex-col items-center relative mb-4"
    :href="`${baseURL}/buy/sourcing-request`"
  >
    <div class="rounded-full flex items-center justify-center bg-white p-0.5 absolute w-20 lg:w-20 lg2:w-auto top-2 lg:top-4">
      <img class="rounded-full" width="100" :src="freelancer.profile_photo" />
    </div>
    <div class="flex flex-col items-center pt-24 lg:pt-30 lg2:pt-32 w-11/12">
      <h1 class="freelancer-name-color lg:text-xl">{{freelancer.public_name}}</h1>
      <div class="flex items-center justify-center pt-1 freelancer-location">
        <img class="pr-2 h-3 lg:h-auto" src="@/assets/icons/green_map.png"/>
        <p class="freelancer-country text-center text-values2 pt-1 market-minimum-height">
          <span>
            {{freelancer.country}}
          </span>
        </p>
      </div>
      <div class="w-full mt-2 border-gray-200 border-width"></div>
      <div class="w-full grid grid-cols-2  divide-x-2">
        <div class="text-center">
        <p class="text-label pt-2 pr-2 card-text-color ">Experience in Sourcing</p>
          <p class="text-values pt-1 pb-1">{{freelancer.experience}}</p>
          <div class="w-full border-gray-200 border-width"></div>
        </div>
        
        <div v-if="freelancer.ratings !== '0.00'" class=" items-center text-center">
          <p class="text-label pt-2 card-text-color">Positive Reviews</p>
          <div class="flex justify-center text-values pt-1 pb-1 border-height">
            <star-rating 
              :rating="handleStarCount(freelancer.ratings)" 
              :show-rating="false" 
              :star-size="handleStarSize" 
              :read-only="true" 
              :max-rating="5" 
              :border-width="1" 
              :increment="0.01"
              active-color="#FDB515" 
              inactive-color="#fff" 
              border-color="#FDB515" 
            ></star-rating>
            <p class=" text-values pl-2">{{Math.round(freelancer.ratings)}}% </p>
          </div>
      <div class="w-full border-gray-200 border-width"></div>
      </div>
      </div>
      <div class="w-full flex text-xs lg:text-md flex-col items-center lg:leading-6 pt-2 pl-2 pr-2">
        <h1 class="card-text-color text-label2 ">Product Expertise</h1>
        <p class="text-center text-values2 pt-1 minimum-height">
          <span 
            v-for="(experty,index) in freelancerExpertise" 
            :key="`${experty}-${index}`" 
          >
            {{ experty }}  {{ index !== freelancerExpertise.length-1 ? '| ' : null }}
          </span>
        </p>
        <h1 class="pt-2 card-text-color text-label2 " >Markets of Experience</h1>
        <p class="text-center text-values2 pt-1 market-minimum-height">
          <span 
            v-for="(experience,index) in freelancerExperience" 
            :key="`${experience}-${index}`" 
          >
            {{ experience }}  {{ index !== freelancerExperience.length-1 ? '| ' : null }}
          </span>
        </p>
      </div>
    <div class="w-full mt-2 border-gray-200 border-width"></div>
    </div>
    <h1 v-if="freelancer.brands.length || freelancer.brand_images.length" class="pt-2 text-xs lg:text-md card-text-color text-label2" >Brands Sourced For</h1>
    <h1 v-else class="pt-8"></h1>
    <div class="flex flex-wrap justify-center py-2 lg:px-2 w-full brand-image-height">
       <div v-for="(brand_image , index) in freelancer.brand_images" :key="`${brand_image}-${index}`" class="w-1/5 flex items-center justify-center ">
        <img :src="brand_image" class="h-50px w-50px"/>
      </div>
      <div class="flex flex-col items-center justify-center">
        <div v-if="freelancer.brands.length" class="text-center  text-values2 flex-wrap flex">
          <span 
            v-for="(brand,index) in freelancer.brands" 
            :key="`${brand}-${index}`"
            class="company-brand-text "
          >
            {{ brand }} &nbsp;
          </span>
        </div>
      </div>
    </div>
  </a>
</template>

<script>
import StarRating from 'vue-star-rating';

export default {
  components: {
    StarRating
  },
  props:{
    freelancer:{
      type:Object,
      default:null
    }
  },
  data() {
    return {
      freelancerExpertise: [],
      freelancerExperience: [],
      isHover: false,
    }
  },
  mounted() {
    this.setFreelancerExpertise()
    this.setFreelancerExperience();
  },
  computed: {
    handleStarSize() {
      if (window.innerWidth < 1200) return 9
      else return 9
    },
    baseURL() {
      return process.env.VUE_APP_SERVER_BASE_URL
    },
  },
  methods: {
    setFreelancerExpertise() {
      if (typeof(this.freelancer.expertise) === 'object') {
        Object.values(this.freelancer.expertise).forEach(experty => {
          this.freelancerExpertise.push(experty)
        })
      }
      else {
        this.freelancer.expertise.forEach(experty => {
          this.freelancerExpertise.push(experty)
        })
      }
    },
    setFreelancerExperience() {
      if (typeof(this.freelancer.sourcing_market_expertise) === 'object') {
        Object.values(this.freelancer.sourcing_market_expertise).forEach(experience => {
          this.freelancerExperience.push(experience)
        })
      }
      else {
        this.freelancer.sourcing_market_expertise.forEach(experience => {
          this.freelancerExperience.push(experience)
        })
      }
    },
    handleStarCount(rating) {
      let rate = rating/20
      return rate
    }
  }
}
</script>
<style scoped lang="scss">
  .card-shadow {
    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
    height: calc(100% - 1rem);
  }
  .freelancer-name-color{
    font-size: 20px;
    line-height: 24px;
    @media (max-width:768px) {
      font-size: 17.03px;
      line-height: 20.43px; 
    }
    color: #201B59;
  }
  .hover-effect {
    transform: scale(1.035);
    box-shadow: 0 0 11px rgba(33,33,33,.2); 
  }
  .card-text-color {
    color : #29B574;
  }
  .text-label {
    font-size: 10px;
    line-height: 12px;
    @media (max-width: 768px) {
      font-size: 8.51px;
      line-height: 10.22px;
      font-weight: 500;
    }
  }
  .text-label2 {
    font-size: 10px;
    line-height: 14px;
    @media (max-width: 768px) {
      font-size: 8.51px;
      line-height: 11.92px;
      font-weight: 500;
    }
  }
  .text-values { 
    font-size: 12px;
    line-height: 14.4px;
    @media (max-width: 768px) {
      font-size: 10.22px;
      line-height: 12.26px;
      font-weight: 500;
    }
  }
  .freelancer-country {
    font-size: 12px;
    line-height: 14.4px;
    @media (max-width: 768px) {
      font-size: 10.22px;
      line-height: 12.26px;
    }
  }
  .border-width {
    border-width: 0.5px;
  }
  .company-brand-text {
    width: 50px;
    min-height: 50px;
    @media (max-width: 768px) {
      width: 35px;
      font-size: 7.5px;
      margin-left: 8px;
      margin-right: 8px;
    }
    @media (max-width: 1154px) and (min-width: 1024px){
      width: 30px;
      margin-left: 6px;
      margin-right: 6px;
    }
    @media (max-width: 1460px) and (min-width: 1336px){
      width: 42px;
    }
    @media (max-width:  1336px) and (min-width: 1154px){
      width: 37px;
    }
    font-size: 8px;
    line-height: 9.6px;
    margin-left: 5px;
    margin-right: 5px;
    display: inline-flex;
    justify-content: center;
    align-items: center;

  }
  .text-values2 { 
    font-size: 12px;
    line-height: 16.8px;
    @media (max-width: 768px) {
      font-size: 10.22px;
      line-height: 14.3px;
      font-weight: 500;
    }
  }
  .freelancer-text {
    height: 62px;
    @media (max-width: 768px) {
      height: 57px;
    }
  }
  .card-width {
    // @media (max-width: 1452px) and (min-width: 1335px) {
    //   width: 17.5rem;
    // }
    @media (max-width: 1452px) and (min-width: 1335px) {
      width: 18.5rem;
    }
    @media (max-width: 1335px) and (min-width: 1254px) {
      width: 17rem;
    }
    @media (max-width: 1253px) and (min-width: 1201px) {
      width: 16.5rem;
    }
    @media (max-width: 1200px) and (min-width: 1154px) {
      width: 16rem;
    }
    @media (max-width: 1153px) and (min-width: 1081px) {
      width: 15rem;
    }
    @media (max-width: 1080px) and (min-width: 1024px) {
      width: 14rem;
    }
  }

  .border-height {
    @media (max-width: 1153px) and (min-width: 1024px) {
      padding-bottom: 1rem;
    }
  }
  .minimum-height{
    min-height: 37.6px;
    @media (max-width: 768px) {
      min-height: 32.6px
    }
  }
  .market-minimum-height{
    min-height: 19.1px;
    @media (max-width: 768px) {
      min-height: 15.6px
    }
  }
  .freelancer-location {
    min-width: -webkit-fill-available;
  }
  .brand-image-height {
    min-height: 50px;
  }
</style>